document.querySelectorAll('a[href^="#"]').forEach(anchor => {
	anchor.addEventListener('click', function (e) {
		e.preventDefault();

		const headerHeight = (document.querySelector('#header').offsetHeight - 33);
		const additionalOffset = 0; // Adjust if necessary
		const targetId = this.getAttribute('href').substring(1);
		const targetElement = document.getElementById(targetId);

		if (targetElement) {
			const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
			const offsetPosition = targetPosition - headerHeight - additionalOffset;

			window.scrollTo({
				top: offsetPosition,
				behavior: 'smooth'
			});
		}
	});
});
